import {
  ConsentDocumentsToSignRequest,
  ListConsentDocumentToSignResponse,
  SignConsentDocumentsRequest,
} from "~/patients/types/consentDocuments";
import { api } from "./axios";

export const listConsentDocumentsToSign = async ({
  organizationId,
}: ConsentDocumentsToSignRequest) => {
  const response = await api.get<ListConsentDocumentToSignResponse[]>(
    `/v1/organizations/${organizationId}/consent-forms/sign`,
  );

  return response.data;
};

export const signConsentDocuments = async ({
  organizationId,
  forms,
}: SignConsentDocumentsRequest) => {
  if (!organizationId) return;

  const response = await api.post<string>(
    `/v1/organizations/${organizationId}/consent-forms/sign`,
    { forms },
  );

  return response.data;
};
